import {LockIcon, PeopleIcon} from '@primer/octicons-react'
import {Text} from '@primer/react'
import {useId} from 'react'

import {LABELS} from '../../constants'
import type {SavedView} from '../../types'
import {viewVisibility} from '../../utils/views-visibility'
import styles from './VisibilityValue.module.css'

export function VisibilityValue({savedView}: {savedView: SavedView}) {
  const isPersonal = viewVisibility(savedView) === 'personal'
  const Icon = isPersonal ? LockIcon : PeopleIcon
  const labelId = useId()

  return (
    <div className={styles.field}>
      <Text id={labelId} className={styles.label}>
        {LABELS.views.visibility}
      </Text>
      <div className={styles.value} role="group" aria-labelledby={labelId}>
        <Icon size={16} />
        <span>{isPersonal ? LABELS.views.personal : LABELS.views.team}</span>
      </div>
    </div>
  )
}
